import React from 'react'
   
const Layout =({children}) =>{
    return(
        <div className="container-fluid">{children}</div>
    )
}
   
export default Layout;